var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("g",{"style":{"fill":"none","stroke":"#000","strokeWidth":"4","strokeLinejoin":"round","strokeMiterlimit":"10","strokeLinecap":"round"}},[React.createElement("circle",{"cx":"63.83","cy":"64.06","r":"56","key":0}),React.createElement("path",{"d":"m32.02 65.54 17.35 22.12 44.25-44.97","key":1})]));
}

Tick.defaultProps = {"height":"44","viewBox":"0 0 128 128"};

module.exports = Tick;

Tick.default = Tick;
